module.exports = __webpack_public_path__ + "img/enviadas-trilha-dashboard.176ecd0b.svg";